import React, { useState } from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { documentTypeIdsToNames } from "FileCabinetContextWrapper";

export const USER_DOC_UPLOAD_TYPES = [
  "image/jpeg",
  "image/jpg",
  "image/gif",
  "image/png",
  "application/pdf",
  "application/doc",
  // "application/vnd.openxmlformats-officedocument.wordprocessingml.document", //.docx
];

export const MAX_SMALL_UPLOAD_BYTES = 10000000; //~10MB -- maximum size for thumbnail generation
export const MAX_UPLOAD_BYTES = 50000000; //~50MB


interface IProps {
  onFocus: () => void;
  onChange?: (documentTypeId: number) => void;
  includeOnlyOptions?: number[];
  initialDocumentTypeId?: number;
}

export function DocumentTypeFormControl(props: IProps): JSX.Element {
  const [documentType, setDocumentType] = useState<number | undefined>(props.initialDocumentTypeId);

  const getOptions = (): JSX.Element[] => {
    const elements: JSX.Element[] = [];
    documentTypeIdsToNames.map((name: string, index: number) => {
      if (index > 0) {
        if (
          !props.includeOnlyOptions ||
          props.includeOnlyOptions.find((i) => i === index)
        ) {
          elements.push(
            <MenuItem key={"m" + index.toString()} value={index}>
              {name}
            </MenuItem>
          );
        }
      }
    });

    return elements;
  };

  return (
    <FormControl fullWidth key={"newfiledoctypeformcontrol"}>
      <InputLabel id="documentTypeLabel">Document Type</InputLabel>
      <Select
        label={"Document Type"}
        labelId={"documentTypeLabel"}
        value={documentType || ""}
        onFocus={props.onFocus}
        onChange={(event: any) => {
          setDocumentType(event.target.value);
          if (props.onChange) {
            props.onChange(event.target.value);
          }

        }}
        style={{ width: "100%", display: "flex", marginBottom: "1rem", textAlign: 'start', alignItems: 'start' }}
      >
        {getOptions()}
      </Select>
    </FormControl>
  );
}